import Observation from "./Observation";
import cls from "./styles.module.css";
import { isEmpty } from "@/utils/is-empty";

type TProps = {
  observations: string[];
};
export default function Observations({ observations: ids }: TProps) {
  if (isEmpty(ids)) return null;
  return (
    <section className={cls.root}>
      <h2 className={cls.header}>Наблюдения</h2>
      <ul>
        {ids.map((id) => (
          <li key={id}>
            <Observation id={id} />
          </li>
        ))}
      </ul>
    </section>
  );
}
